/* A module that enables our ZeroClipboard buttons and returns an object with
 * an `activateClipboardButtons` method.
 *
 * Automatically activates the buttons on page load. If you need to activate
 * the buttons again because you added more markup to the page, call
 * `c2.clipboard.activateClipboardButtons()`.
 *
 * The clipboard button must have class '.clipboard-button' and an attribute
 * 'data-clipboard-target' whose value is the id of a target element that
 * contains the text to be copied.
 */
(function(c2, $) {
  "use strict";

  /*
   * Initialize. Called by c2.init after c2.settings has been defined.
   */
  function init() {
    activateClipboardButtons();
  }

  function hidePopover(popover) {
    setTimeout(function() {
      popover.hide()
    }, 1000);
  }

  function activateClipboardButtons() {
    const clipButtons = document.getElementsByClassName("clipboard-button");

    function handler(e) {
      const btn = e.currentTarget;
      const popover = new bootstrap.Popover(btn, {
        title: 'Copied!'
      })
      // Use getAttribute to reliably read from AJAX-injected elements, avoiding
      // jQuery's data cache which is only populated for pre-existing DOM elements.
      const directText = btn.getAttribute("data-clipboard-text");
      const targetId = btn.getAttribute("data-clipboard-target");
      const text = directText || (targetId ? $(targetId).text().trim() : '');
      navigator.clipboard.writeText(text).then(
        () => { popover.toggle(); hidePopover(popover) },
        () => { popover.setContent({
            '.popover-header': 'Did not copy.',
            '.popover-body': ''
          }); popover.toggle(); hidePopover(popover)}
      );
    }

    Array.from(clipButtons).forEach(btn => btn.addEventListener("click", handler));

    return navigator.clipboard;
  }

  // return an object that contains our public functions
  c2.clipboard = {
    activateClipboardButtons: activateClipboardButtons,
    init: init
  };
})(window.c2, $);
